var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[(_vm.hasErrors)?_c('ErrorPage'):(_vm.loading)?_c('Loading'):(_vm.authenticated)?_c('PrivateLayout'):_c('PublicLayout')],1),_c('Notification'),_c('ConfirmationModal'),_c('RefreshApp'),_c('AboutModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }